import { render, staticRenderFns } from "./WxOperaRecordPanel.vue?vue&type=template&id=5de0a302&"
import script from "./WxOperaRecordPanel.vue?vue&type=script&lang=js&"
export * from "./WxOperaRecordPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports